import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalContentList } from './ModalContentList';
import { FullscreenContainer, GlobalStyle } from './styles';
import { Overlay } from '../Overlay';
export var Modal = function (_a) {
  var _b = _a.isVisible,
    isVisible = _b === void 0 ? true : _b,
    onClick = _a.onClick,
    hideBackdrop = _a.hideBackdrop,
    _c = _a.containerPosition,
    containerPosition = _c === void 0 ? 'center' : _c,
    modalContentList = _a.modalContentList,
    events = _a.events,
    _d = _a.size,
    size = _d === void 0 ? 'medium' : _d,
    _e = _a.fullscreenBgColor,
    fullscreenBgColor = _e === void 0 ? 'primary' : _e,
    _f = _a.startingModalContentItem,
    startingModalContentItem = _f === void 0 ? 0 : _f;
  return _jsxs(_Fragment, {
    children: [isVisible && _jsx(GlobalStyle, {}), size === 'fullscreen' ? _jsx(FullscreenContainer, {
      fullscreenBgColor: fullscreenBgColor,
      children: _jsx(ModalContentList, {
        events: events,
        modalContentList: modalContentList,
        startingModalContentItem: startingModalContentItem,
        size: size,
        fullscreenBgColor: fullscreenBgColor,
        containerPosition: containerPosition
      })
    }) : _jsx(Overlay, {
      isVisible: isVisible,
      onClick: onClick,
      hideBackdrop: hideBackdrop,
      containerPosition: containerPosition,
      children: _jsx(ModalContentList, {
        events: events,
        modalContentList: modalContentList,
        startingModalContentItem: startingModalContentItem,
        size: size,
        fullscreenBgColor: fullscreenBgColor,
        containerPosition: containerPosition
      })
    })]
  });
};